import * as ACTION_TYPES from '../actions/action_types'

export interface LayoutStateType {
  collapsed: boolean
  open_modal_help: boolean
  innerHeight: string
  frame: boolean
  toast: A
  requiredToggle: boolean
}
export const initialState = {
  collapsed: true,
  open_modal_help: false,
  innerHeight: '100vh',
  frame: true,
  toast: {},
  requiredToggle: false,
}

const LayoutReducer = (state: LayoutStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.TOGGLE_SIDER:
      return {
        ...state,
        collapsed: !state.collapsed,
      }
    case ACTION_TYPES.GET_WINDOW_HEIGHT:
      return {
        ...state,
        innerHeight: action.innerHeight,
      }
    case ACTION_TYPES.OPEN_MODAL_HELP:
      return {
        ...state,
        open_modal_help: !state.open_modal_help,
      }
    case ACTION_TYPES.SHOW_THEME:
      return {
        ...state,
        frame: false,
      }
    case ACTION_TYPES.TOAST:
      return {
        ...state,
        toast: action.payload,
      }
    case ACTION_TYPES.REQUIRED_PLAN:
      return { ...state, requiredToggle: action.requiredToggle }
    default:
      return {
        ...state,
        frame: true,
      }
  }
}
export default LayoutReducer
